import {
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
import { SupportVideoViewsFormModel } from './SupportVideoViewsFormModel';

export interface ComboFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}

abstract class AbstractComboFormModel
  extends SupportVideoViewsFormModel
  implements ComboFormModel
{
  supportProgressAdViewObjective = true;

  get campaignAdType(): AdType {
    return AdType.COMBO;
  }

  override get canUseVideoProgressTracking(): boolean {
    return true;
  }
}

export class EditComboFormModel extends AbstractComboFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return false;
  }
  get canEditPriceModel(): boolean {
    return false;
  }
  canEditOptimize(): boolean {
    return false;
  }
}

export class CreateComboFormModel extends AbstractComboFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('create', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return true;
  }
  get canEditPriceModel(): boolean {
    return true;
  }
}
